export const debounceTimes = {
    baseDebounce: 300,
    apiDebounce: 300,
    formDebounce: 400,
    filterDebounce: 300,
};
